import { SegmentationCanvas } from './SegmentationCanvas.tsx';
import { SegmentationUI } from './UI/SegmentationUI.tsx';
import { useParams } from 'react-router-dom';
import { useJawsScan } from '@hooks/useJawsScan.ts';
import useSegmentationStore from '@segmentation/hooks/useSegmentationStore.ts';
import { Suspense, useEffect } from 'react';
import LoadingPage from '@/components/ui/LoadingPage.tsx';
import useThreeStore from '@/modules/three/hooks/useThreeStore.ts';

const SegmentationContent = ({ scanId }: { scanId: string }) => {
  const { jaws } = useSegmentationStore();
  const { data, isError } = useJawsScan(scanId);
  const { isLoading: isThreeLoading } = useThreeStore();

  if (isError) {
    return <div>Error loading segmentation data</div>;
  }

  return (
    <>
      {jaws ? <SegmentationUI /> : null}
      <div className={'relative w-full h-full'}>
        {isThreeLoading && <LoadingPage loadingText="Loading segmentation..." />}
        <SegmentationCanvas jawsScan={data} />
      </div>
    </>
  );
};

export const Segmentation = () => {
  const { scanId } = useParams<{ patientId: string; scanId: string }>();
  const { setScanId } = useSegmentationStore();

  useEffect(() => {
    if (scanId) setScanId(scanId);
  }, [scanId, setScanId]);

  if (!scanId) {
    return <div>Error loading segmentation data</div>;
  }

  return (
    <Suspense fallback={<LoadingPage loadingText="Loading segmentation..." />}>
      <SegmentationContent scanId={scanId} />
    </Suspense>
  );
};
